module.exports = __webpack_public_path__ + "img/checkbox.6e875265.png";